export const MESSAGE_TYPES = ['default', 'info', 'success', 'caution', 'error'];
